<template>
  <div id="app" :class="mainClass">
    <router-view />
  </div>
</template>

<script>
// import { initializeFullStory, destroyFullStory } from '@/common/fullstory'
import { mapState } from "vuex";
export default {
  name: "App",
  computed: {
    mainClass() {
      return {
        "bg-off-white-app": [
          "CreateAbSplit",
          "EditABCampaign",
          "CreateAutomation",
          "WebformPublish",
          "WebformChooseTemplates",
          "CreateWebform",
          "WebformEdit",
          "AutomationStep1",
          "AutomationEditStep1",
          "TemplateThemes",
          "TemplateCode",
          "TemplateLayout",
          "ImportHtml",
          "ImportZip",
          "PasteCode",
          // "AccountPlugins",
          "CreateListType",
          "CreateListImport",
          "LogsContactImport",
          "LogsContact",
          "CreateListIndividual",
          "CreateListUpload",
          "CreateListUploadMap",
          "CreateListCopyPaste",
          "CreateSegment",
        ].includes(this.$route.name),
        "br-bull-check": ["WebformEdit"].includes(this.$route.name),
        "bull-check bg-off-white-app": [
          "AutomationStep2",
          "AutomationStep3",
          "AutomationEditStep2",
          "AutomationEditStep3",
          "AutomationPreview",
        ].includes(this.$route.name),
      };
    },
    ...mapState({
      toasterMessage: (state) => state.common.toasterMessage,
    }),
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || "Mailercloud";
    },
    toasterMessage(val) {
      if (val) {
        this.toastMessage(val);
      }
    },
  },
  created() {
    if (document.getElementById("titleImage")) {
      document.getElementById(
        "titleImage"
      ).href = require("@/assets/img/brand/mailercloud/brand-fav.png");
    }
    // var loginData = JSON.parse(this.$ls.get("login_data"));
    // if (process.env.VUE_APP_FULLSTORY_CODE && loginData && loginData.token) {
    //   initializeFullStory()
    // } else if (process.env.VUE_APP_FULLSTORY_CODE) {
    //   destroyFullStory()
    // }
  },
  metaInfo() {
    return {
      title: "Mailercloud",
      meta: [
        { name: "description", content: "Mailercloud", vmid: "description" },
        { property: "og:site_name", content: "Mailercloud" },
        { property: "og:type", content: "website" },
        { property: "og:title", content: "Mailercloud", vmid: "ogtitle" },
        {
          property: "og:description",
          content: "Mailercloud",
          vmid: "ogdescription",
        },
        {
          property: "og:image",
          content: "https://www.mailercloud.com/images/og-mailercloud.jpg",
        },
      ],
    };
  },
};
</script>
